/** Maximum length of a single route param or search-param value in the context snapshot. */
export const ASSISTANT_LOCATION_VALUE_MAX_CHARACTERS = 1_024;
